export default {
  DEVICE_FAQ_HEADING: `OK {{patientName}}, revisemos primero estas cosas:`,
  DEVICE_FAQ_INTRO_FIRST: `Primero, asegurémonos de que:`,
  DEVICE_FAQ_INTRO_ACCORDION: `Marque esto para comenzar`,
  DEVICE_FAQ_WIFI_RECOMMENDATION: `Estás cerca de tu enrutador WiFi.`,
  DEVICE_FAQ_STREAMING_RECOMMENDATION: `Nadie en tu casa está transmitiendo videos o jugando videojuegos.`,
  DEVICE_FAQ_VOLUME_RECOMMENDATION: `Tu volumen no está silenciado y está alto.`,
  DEVICE_FAQ_PERMISSIONS_RECOMMENDATION: `Selecciona <strong>Permitir</strong> en cualquier momento que tu navegador te pida activar el micrófono.`,
  DEVICE_FAQ_CONTENT: `Recuerda que la aplicación puede necesitar un segundo para responder, así que, por favor, ten paciencia mientras intentas estos pasos adicionales.`,
  DEVICE_FAQ_HELP_HEADING: `OK {{patientName}} - veamos qué pasa`,

  // Used in both fullFaq and deviceFaq
  FAQ_SIGNPOST: `¿Continúas teniendo problemas? Intenta reiniciar tu dispositivo o llama a tu consultorio.`,
  FAQ_SIGNPOST_LINK: `Copiar el enlace de esta visita`,
};
